import { IBuscaAcordoRequest } from './types';
import api from "../api";
import { IAcordo } from 'interfaces/Acordo';

export const buscaAcordoService = async (data: IBuscaAcordoRequest) => await api.post<IAcordo[]>('busca-acordo', data);